import React, { useEffect, useState } from "react";
import { Home } from "grommet-icons";
import axios from "axios";
import { format } from "date-fns";
import { take } from "lodash";
import { useNavigate } from "react-router-dom";
import { useUser } from "../utils/AccountStore";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export interface Schedule {
    id: string;
    title: string;
    time: string;
    location: string;
    description: string;
    speaker: string;
    allDay: boolean;
}

interface Attendee {
    id: string;
    mySchedule: string[];
}

const SchedulePage = () => {
    const [schedules, setSchedules] = useState<Schedule[]>([]);
    const [filteredSchedules, setFilteredSchedules] = useState<Schedule[]>([]);
    const { user, getUser } = useUser();
    const [filter, setFilter] = useState("");
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [locations, setLocations] = useState<string[]>([]);
    const [days, setDays] = useState<string[]>([]);
    const [locationFilter, setLocationFilter] = useState<string[]>([]);
    const [favouritesFilter, setFavouritesFilter] = useState<boolean>(false);
    const [dayFilter, setDayFilter] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(100);

    useEffect(() => {
        const fetchSchedules = async () => {
            const response = await axios.get(`${Server}/api/schedules`);
            return response.data;
        };

        const init = async () => {
            try {
                const data: Schedule[] = await fetchSchedules();
                const sorted = data.sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
                setSchedules(sorted);
                setDays(sorted.map((s) => format(new Date(s.time), "EEEE")).filter((v, i, self) => self.indexOf(v) === i));
                setLocations(sorted.map((s) => s.location).filter((v, i, self) => self.indexOf(v) === i));
            } catch (err) {
                alert("Error loading schedules");
            }
            setLoading(false);
        };

        init();
    }, []);

    useEffect(() => {
        const result = schedules.filter((s) => {
            const matchesSearch = s.title.toLowerCase().includes(filter.toLowerCase());
            const matchesDay = dayFilter ? format(new Date(s.time), "EEEE") === dayFilter : true;
            const matchesLocation = locationFilter.length ? locationFilter.includes(s.location) : true;
            const matchesFavourites = favouritesFilter ? user.mySchedule.includes(s.id) : true;

            return matchesSearch && matchesDay && matchesLocation && matchesFavourites;
        });

        setFilteredSchedules(result);
    }, [schedules, filter, dayFilter, locationFilter, favouritesFilter, user]);

    const toggleFavorite = (id: string) => {
        const updated = user.mySchedule.includes(id) ? user.mySchedule.filter((sid) => sid !== id) : [...user.mySchedule, id];

        axios
            .post(`${Server}/api/attendees/toggleMySchedule`, {
                userID: user.id,
                scheduleID: id,
            })
            .then(() => {
                getUser();
            });
    };

    const clearFilters = () => {
        setFilter("");
        setDayFilter("");
        setLocationFilter([]);
        setFavouritesFilter(false);
        setShowFilterModal(false);
    };

    const navigate = useNavigate();

    return (
        <div className="p-4 flex flex-col gap-2 w-full">
            <div className="grid grid-cols-[1fr_auto_1fr] items-center w-full">
                <Home className="cursor-pointer" color="#1e3a8a" onClick={() => navigate('/home')} />
                <h2 className="text-blue-600 text-lg font-bold text-center"></h2>
                <div />
            </div>

            <div className="flex justify-center overflow-auto rounded-lg">
                <TransformWrapper
                    minScale={1}
                    maxScale={5}
                    wheel={{ step: 0.1 }}
                    doubleClick={{ disabled: false, step: 1 }}
                    pinch={{ step: 5 }}
                    centerZoomedOut={true}
                    limitToBounds
                >
                    <TransformComponent>
                        <img
                            src={"https://scadsyscloudblobs.blob.core.windows.net/expo-file-blobs/tandem.web--cb01789d-ab5b-4ccf-aaaf-46cd5a1efd81-agenda.jpg"}
                            alt="FloorPlan"
                            className="max-w-full max-h-[90vh] rounded-lg"
                        />
                    </TransformComponent>
                </TransformWrapper>
            </div>
        </div>
    );
};

export default SchedulePage;
